import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5982ccc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formula-detail-wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "multiple"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "total" }
const _hoisted_7 = { class: "service-price-wrap" }
const _hoisted_8 = { class: "current-price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "￥", -1))
const _hoisted_10 = {
  key: 0,
  class: "origin-price"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculationList, (group, groupIndex) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: groupIndex }, [
        (groupIndex !== 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "+"))
          : _createCommentVNode("", true),
        (_ctx.calculationList.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "（ "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.cal_desc
          }, [
            index
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "X"))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(item.cal_detail?.replace('.00', '')), 1),
              _createTextVNode(" " + _toDisplayString(item.cal_desc), 1)
            ])
          ], 64))
        }), 128)),
        (_ctx.calculationList.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ）"))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _createElementVNode("span", _hoisted_6, [
      _createTextVNode(" =   "),
      _createElementVNode("span", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(_toDisplayString(_ctx.priceData.current_price / 100), 1)
        ]),
        (_ctx.priceData.current_price !== _ctx.priceData.origin_price)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "￥" + _toDisplayString(_ctx.priceData.origin_price / 100), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}